
const modal = () => {

	// $.featherlight.defaults.closeOnClick = false;
	// $.featherlight.defaults.loading = '<i class="fas fa-cog fa-pulse text-primary"></i> Espere...';
	// $.featherlight.defaults.otherClose = '.btn-close';

	const $modal_options = {
		clickClose: false,
		fadeDuration: 190,
		showSpinner: true,
		modalClass: 'page-modal'
	};

	// Bind .ajax class to Featherlight Popup
	// $(document).on('click', 'a.ajax', function(e){

	// 	var $link = $(this);
	// 	var $href = $(this).attr('href');

	// 	if($href.length > 1)
	// 		$.featherlight($href, { type: 'ajax' });

	// 	e.preventDefault();

	// });


	$(document).on('click', 'a.ajax', function(event){
		

		$('.page-modal').remove();		

		event.preventDefault();
		this.blur(); // Manually remove focus from clicked link.		

		if(this.href.length > 0 && this.href !== document.location.href + '#')
		{

			$.get(this.href, function(html) {

			$('<div />', {
			        "class": 'page-modal',
			        }).appendTo('body').html(html).modal($modal_options)
					  .find(".page-modal input[autofocus]").focus();

			});
		}

		

	});

	$(document).on('click', '.btn-close', () => $.modal.close());

}

export { modal }